import $http from "../axios";

const state = {
  userInfo: {},
  companyInfo: {},
  address: {},
  permissions: {},
  preferences: {
    storesOrder: "chronological",
    timezone: -3
  }
};

const getters = {
  userInfo: state => {
    return state.userInfo;
  },

  companyInfo: state => {
    return state.companyInfo;
  },

  address: state => {
    return state.address;
  },

  permissions: state => {
    return state.permissions;
  },

  preferences: state => {
    return state.preferences;
  }
};

const actions = {
  getAccountData({ commit }, email) {
    if (!email) {
      return new Promise((resolve, reject) => {
        $http
          .get("account-data")
          .then(res => {
            if (res.data.result === "ok") {
              commit("SET_ACCOUNT_DATA", res.data.payload);
            }
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
    return { data: { result: "ok" } };
  },

  updatePassword(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-password", {
          password: data.password,
          newPassword: data.newPassword
        })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateStoresOrderPreference({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-stores-order-preference", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_STORES_ORDER_PREFERENCE", data.storesOrder);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateTimezone({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-timezone", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_TIMEZONE", data.timezone);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  clearAccountData({ commit }) {
    commit("CLEAR_ACCOUNT_DATA");
  }
};

const mutations = {
  SET_ACCOUNT_DATA(state, data) {
    state.userInfo = data.userInfo;
    state.companyInfo = data.partner.companyInfo;
    state.address = data.partner.address;
    state.permissions = data.permissions;
    state.preferences = data.preferences;
  },

  CLEAR_ACCOUNT_DATA(state) {
    state.userInfo = {};
    state.companyInfo = {};
    state.address = {};
    state.permissions = {};
  },

  UPDATE_STORES_ORDER_PREFERENCE(state, storesOrder) {
    state.preferences.storesOrder = storesOrder;
  },

  UPDATE_TIMEZONE(state, timezone) {
    state.preferences.timezone = timezone;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
